













import Vue from 'vue'
export default Vue.extend({
  props: {
    url: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    highlight: {
      type: Boolean,
      default: false
    },
    id: {
      type: Number,
      required: true
    }
  },
  methods: {
    changeRoute() {
      this.$emit('onChangeCategory', {
        id: this.id,
        url: this.url
      })
    }
  }
})
